(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hallway-cart-shipping-notice"] && !Shopify.designMode) return;
  try {
    const updateCartShippingNotice = function(cart) {
    const notices = document.querySelectorAll('[data-hw-shipping-notice]');
    
    if (notices.length === 0) return;

    notices.forEach(container => {
      const threshold = parseInt(container.getAttribute('data-hw-shipping-notice-threshold'));
      const spendMoreTpl = container.getAttribute('data-hw-shipping-notice-spend-more');
      const qualifiedText = container.getAttribute('data-hw-shipping-notice-qualified');
      const textSpan = container.querySelector('.hw__free_shipping_notice');
      
      // 1. Visibility toggle
      if (cart.item_count === 0) {
        container.classList.add('hw__cart_dynamic_notices--empty');
        return;
      } else {
        container.classList.remove('hw__cart_dynamic_notices--empty');
      }

      // 2. Logic & Text Update
      if (cart.total_price < threshold) {
        const remaining = threshold - cart.total_price;
        const moneyFormat = (window.theme && window.theme.settings) ? window.theme.settings.moneyFormat : '${{amount}}';
        const formattedRemaining = (window.theme && window.theme.Currency) 
                                 ? window.theme.Currency.formatMoney(remaining, moneyFormat) 
                                 : (remaining / 100).toFixed(2);

        const finalText = spendMoreTpl.replace('## spend_more_amount ##', formattedRemaining);
        
        if (textSpan) {
          textSpan.textContent = finalText;
          textSpan.classList.remove('hw__free-shipping-notes-active');
          textSpan.classList.add('hw__free-shipping-notes-ineligible');
        }
      } else {
        if (textSpan) {
          textSpan.textContent = qualifiedText;
          textSpan.classList.remove('hw__free-shipping-notes-ineligible');
          textSpan.classList.add('hw__free-shipping-notes-active');
        }
      }
    });
  };

  ['cart:updated', 'ajaxProduct:added', 'rebuy.add'].forEach(event_name => {
    document.addEventListener(event_name, function(evt) {

      let cart = null;

      if (evt.detail &&
          evt.detail.cart && 
          typeof evt.detail.cart.total_price === 'number' &&
          typeof evt.detail.cart.item_count === 'number') {
        cart = evt.detail.cart;
      }

      if (cart) {
        updateCartShippingNotice(cart);
      } else {
        if (window.theme && window.theme.cart) {
           theme.cart.getCart().then(function(cart) {
             updateCartShippingNotice(cart);
           });
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hallway-vto-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('page:loaded', function() {

      console.log('[Hallway] FittingBox integration loaded');

      let modalVirtualTryOn = new theme.Modals('hw__modal_virtual_try_on', 'hallway-modal-virtual-try-on');
      window.hw__initialisedVirtualTryOn = false;
      window.hw__vtoRequestedMode = 'live';
      window.hw__virtualTryOnFrames = document.getElementById('hw__virtual-try-on__frames__slider');
      window.hw__virtualTryOnLensTints = document.getElementById('hw__virtual-try-on__lenses__slider');

      // Capture which mode was requested when a button is clicked, before the modal opens
      document.querySelectorAll('[data-hw-vto-mode]').forEach(function(btn) {
          btn.addEventListener('click', function() {
              window.hw__vtoRequestedMode = btn.dataset.hwVtoMode || 'live';
          });
      });

      document.addEventListener('modalOpen.hw__modal_virtual_try_on', function() {

          // Use the single globally tracked model ID
          const activeFrameId = window.hw__vto_3d_viewer__current_model_id;

          if (!window.hw__initialisedVirtualTryOn) {

              console.log('[Hallway] FittingBox instance creation on modal open');

              const scriptEl = document.createElement('script');
              scriptEl.addEventListener('load', function() {

                  window.hw__initialisedVirtualTryOn = true;

                  window.hw__fitmixWidget = FitMix.createWidget(
                      'fitmix-container',
                      {
                          apiKey: 'WnRN6NtMP5k2aXkn939Pl2AVztgKKg6Clq26YXA3',
                          frame: activeFrameId.toString()
                      },
                      function(liveSupported) {

                          console.log(`[Hallway] FittingBox instance created. Live html5 mode supported: ${liveSupported}`);

                          window.hw__fitmixWidget.startVto(window.hw__vtoRequestedMode);
                          console.log(`[Hallway] FittingBox: Started in '${window.hw__vtoRequestedMode}' mode`);

                          let flickityLenses;
                          let flickityFrames;

                          // initialise slider for lens picker, if enabled
                          if (window.hw__virtualTryOnLensTints) {

                              // initialise slider for lens selection
                              flickityLenses = new Flickity('#hw__virtual-try-on__lenses__slider', {
                                  imagesLoaded: 'true',
                                  cellAlign: 'left',
                                  contain: true,
                                  freeScroll: true,
                                  pageDots: false,
                                  prevNextButtons: true
                              });

                              // set the selected slide when clicking on a lens
                              document.querySelectorAll('.hw__virtual_try_on__lens_picker__lens').forEach(elSelectedLens => {
                                  elSelectedLens.addEventListener('click', evt => {
                                      evt.preventDefault();
                                      flickityLenses.select(elSelectedLens.dataset.index);
                                  });
                              });

                              // change the lens when the selected slide is selected
                              flickityLenses.on('select', (index) => {

                                  const elSelectedLens = document.querySelector(`.hw__virtual_try_on__lens_picker__lens[data-index="${index}"]`);

                                  console.log(`[Hallway] Selected lens slide index ${index}`);
                                  console.log(`[Hallway]`, elSelectedLens);

                                  // load the selected lens in VTO app
                                  if (elSelectedLens.dataset.lensType === 'none') {
                                      window.hw__fitmixWidget.restoreLensDefaultMaterial();
                                  } else {
                                      window.hw__fitmixWidget.restoreLensDefaultMaterial();
                                      window.hw__fitmixWidget.setLensMaterial(elSelectedLens.dataset.lensMaterial.toString());
                                  }

                                  // update selected lens variant title label
                                  document.querySelectorAll('.hw__virtual_try_on__label__lens').forEach((elLabel) => {
                                      elLabel.textContent = elSelectedLens.dataset.lensName;
                                  });

                              });

                          }

                          if (window.hw__virtualTryOnFrames) {

                              // initialise slider for SKU selection
                              flickityFrames = new Flickity('#hw__virtual-try-on__frames__slider', {
                                   imagesLoaded: 'true',
                                   cellAlign: 'left',
                                   contain: true,
                                   freeScroll: true,
                                   pageDots: false,
                                   prevNextButtons: true
                              });

                              // set the selected slide when clicking on a frame
                              document.querySelectorAll('.hw__virtual-try-on__frames__slide').forEach(elSelectedFrame => {
                                  elSelectedFrame.addEventListener('click', evt => {
                                      evt.preventDefault();
                                      flickityFrames.select(elSelectedFrame.dataset.index);
                                  });
                              });

                              // change the frame when the selected slide is selected
                              flickityFrames.on('select', (index) => {

                                  const elSelectedFrame = document.querySelector(`.hw__virtual-try-on__frames__slide[data-index="${index}"]`);

                                  console.log(`[Hallway] Selected frame slide index ${index}`);
                                  console.log(`[Hallway]`, elSelectedFrame);

                                  // load the selected frame in VTO app
                                  window.hw__fitmixWidget.setFrame(elSelectedFrame.dataset.fitmixId.toString());

                                  // keep the global frame ID in sync
                                  window.hw__vto_3d_viewer__current_model_id = elSelectedFrame.dataset.fitmixId;

                                  // update selected frame variant title label
                                  document.querySelectorAll('.hw__virtual_try_on__label__frame').forEach((elLabel) => {
                                      elLabel.textContent = elSelectedFrame.dataset.variantTitle;
                                  });

                                  // Set lens back to clear as we can't reapply existing one (FitMix limitation)
                                  if (window.hw__virtualTryOnLensTints) {
                                      flickityLenses.select(0);
                                  }

                              });

                              // select the initial frame
                              const elInitialSlide = document.querySelector(`#hw__virtual-try-on__frames__slider [data-fitmix-id="${window.hw__vto_3d_viewer__current_model_id}"]`);
                              if (elInitialSlide) {
                                  flickityFrames.select(elInitialSlide.dataset.index);
                              }

                              // toggle open/close customise panel
                              document.querySelectorAll('.hw__virtual_try_on__toggle_link').forEach((el) => {
                                  el.addEventListener('click', (evt) => {
                                      evt.preventDefault();
                                      const elPanel = document.getElementById('hw__virtual_try_on__customise_container');
                                      if (elPanel.classList.contains('hw__virtual_try_on__customise_container_open')) {
                                          elPanel.classList.remove('hw__virtual_try_on__customise_container_open');
                                          evt.target.textContent = evt.target.dataset.labelClosed;
                                      } else {
                                          elPanel.classList.add('hw__virtual_try_on__customise_container_open');
                                          evt.target.textContent = evt.target.dataset.labelOpened;
                                          flickityFrames.resize();
                                      }
                                  });
                              });

                          }
                      }
                  );

              });
              scriptEl.src = '//vto-advanced-integration-api.fittingbox.com/index.js';
              document.body.appendChild(scriptEl);

          } else {

              // Already initialised — switch to the correct frame and mode
              console.log(`[Hallway] FittingBox: Already initialised, switching to '${window.hw__vtoRequestedMode}' mode`);
              window.hw__fitmixWidget.setFrame(activeFrameId.toString());
              window.hw__fitmixWidget.startVto(window.hw__vtoRequestedMode);

          }

      });

      // Stop VTO when modal closes to release the camera
      document.addEventListener('modalClose.hw__modal_virtual_try_on', function() {
          if (window.hw__fitmixWidget) {
              window.hw__fitmixWidget.stopVto();
              console.log('[Hallway] FittingBox: Stopped VTO on modal close');
          }
      });

  });
  } catch(e) { console.error(e); }
})();

})();
